import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";

import App from "./App.tsx";
import { hydrateUser } from "./features/auth/slices/authSlice.ts";
import { store } from "./shared/store/index.ts";

import "./styles/index.css";

// Hidrata dados do usuário do localStorage criptografado
store.dispatch(hydrateUser());

createRoot(document.getElementById("root")!).render(
  <Provider store={store}>
    <App />
  </Provider>
);
